// extracted by mini-css-extract-plugin
export default {"gray_bg":"eom01T6uak8SzVQ728dh","grayBg":"eom01T6uak8SzVQ728dh","tab_outer":"mQHQS7Sj5jqIm0k2Ik3w","tabOuter":"mQHQS7Sj5jqIm0k2Ik3w"};